<template>
  <div id="rewarder">
    <div class="row">
      <div class="col-md-8">
        <perfect-scrollbar class="ps">
          <div class="contest-list">
            <div
              class="contest-item"
              :class="{
                approved: approvalStatus === 'approved',
                undecided: approvalStatus === 'undecided',
                pending: approvalStatus === 'pending',
              }"
              @click="onClickContest(item)"
              v-for="(item, index) in items"
              :key="index"
            >
              <div class="contest-thumbnail">
                <img :src="item.thumbnailUrl" />
              </div>
              <div class="contest-detail">
                <h3 class="contest-title">{{ item.title }}</h3>
                <div class="attributes">
                  <div class="attribute">
                    <div class="attribute-name">Creation Date:</div>
                    <div class="attribute-value">{{ item.date }}</div>
                  </div>
                  <div class="attribute">
                    <div class="attribute-name">Quantity:</div>
                    <div class="attribute-value">{{ item.quantity }}</div>
                  </div>
                  <div class="attribute">
                    <div class="attribute-name">Awarded:</div>
                    <div class="attribute-value">{{ item.awarded }}</div>
                  </div>
                  <div class="attribute">
                    <div class="attribute-name">Type:</div>
                    <div class="attribute-value">{{ item.type }}</div>
                  </div>
                  <div class="attribute">
                    <div class="attribute-name">Status:</div>
                    <div class="attribute-value">{{ item.status }}</div>
                  </div>
                  <div class="attribute">
                    <div class="attribute-name">Connections:</div>
                    <div class="attribute-value">{{ item.connections }}</div>
                  </div>
                </div>
                <div class="hastag">
                  <small>Last update: 3m ago</small>
                </div>
              </div>
              <div class="approval-status">
                <img
                  :src="images.undecidedIcon"
                  v-if="approvalStatus === 'undecided'"
                />
                <img
                  :src="images.pendingIcon"
                  v-if="approvalStatus === 'pending'"
                />
                <img
                  :src="images.approvedIcon"
                  v-if="approvalStatus === 'approved'"
                />
                <img
                  :src="images.publishedIcon"
                  v-if="approvalStatus === 'published'"
                />
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
      <perfect-scrollbar class="col-md-4">
        <FilterList>
          <template v-slot:header>Rewards Options</template>
          <template v-slot:btn>
            <div class="button-add">
              <div class="row">
                <div class="col-md-6 m-0 pt-1 pb-1 pl-3 pr-3">
                  <button class="btn btn-secondary btn-block rounded">
                    ACTIVATE
                  </button>
                </div>
                <div class="col-md-6 m-0 pt-1 pb-1 pl-3 pr-3">
                  <button class="btn btn-secondary btn-block rounded">
                    DEACTIVATE
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 m-0 pt-1 pb-1 pl-3 pr-3">
                <div class="button-add">
                  <button class="btn btn-secondary btn-block rounded" @click="onClickAddRewards()">
                    ADD REWARD
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 m-0 pt-1 pb-1 pl-3 pr-3">
                <div class="button-add">
                  <button class="btn btn-secondary btn-block rounded" @click="onClickAddBadge()">
                    ADD BADGE
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:headerfilter>Filter Rewards</template>
          <template v-slot:filter>
            <div class>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search content"
                  aria-label="Search content"
                  aria-describedby="basic-addon2"
                  v-model="search"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="row filter">
              <div class="col-md-4 py-1">
                <button class="btn btn-secondary btn-block">Active</button>
              </div>
              <div class="col-md-4 py-1">
                <button class="btn btn-secondary btn-block">Inactive</button>
              </div>
            </div>
            <div class="mt-2">
              <select v-model="sort1" class="form-control">
                <option value="Sort by date posted">Sort by date posted</option>
              </select>
            </div>
            <div class="mt-2">
              <select v-model="sort2" class="form-control">
                <option value="All my Experiences">All my Experiences</option>
              </select>
            </div>
            <div class="mt-2">
              <select v-model="sort3" class="form-control">
                <option value="All Types">All Types</option>
              </select>
            </div>
            <div class>
              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-apply btn-block" @click="onSearch">
                    <span></span>
                    <span>APPLY</span>
                    <i class="fas fa-check"></i>
                  </button>
                </div>
                <div class="col-md-6">
                  <button class="btn btn-reset btn-block" @click="onReset">
                    <span></span>
                    <span>RESET FILTERS</span>
                    <i class="fas fa-redo"></i>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </FilterList>
      </perfect-scrollbar>
    </div>
    <transition name="fade">
      <RewarderForm
        v-if="showRewardsForm"
        @close="showRewardsForm = false"
      />
    </transition>
    <transition name="fade">
      <BadgesForm
        v-if="showBadgesForm"
        @close="showBadgesForm = false"
      />
    </transition>
  </div>
</template>

<script>
import RewarderForm from "./RewarderForm";
import thumbnail from "@/assets/images/dummy-contest-1.png";
import undecidedIcon from "@/assets/images/icons/ew-icon_undecided.svg";
import pendingIcon from "@/assets/images/icons/ew-icon_pending.svg";
import approvedIcon from "@/assets/images/icons/ew-icon_approved.svg";
import publishedIcon from "@/assets/images/icons/ew-icon_published.png";
import FilterList from "@/components/Filter";
import moment from "moment";
import img01 from "@/assets/images/shutterstock_380872402.jpg";
import img02 from "@/assets/images/shutterstock_1351167989.jpg";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

export default {
  components: {
    RewarderForm,
    FilterList,
    PerfectScrollbar,
  },
  data() {
    return {
      images: {
        thumbnail,
        undecidedIcon,
        pendingIcon,
        approvedIcon,
        publishedIcon,
      },
      approvalStatus: "published",
      showRewardsForm: false,
      showBadgesForm: false,
      sort1: "Sort by date posted",
      sort2: "All my Experiences",
      sort3: "All Types",
      search: null,
      items: [
        {
          thumbnailUrl: img01,
          title: "Repeat Customer",
          date: "24/11/2020",
          quantity: "Unlimited",
          awarded: 125,
          type: "Manual",
          status: "Active",
          connections: 1,
        },
        {
          thumbnailUrl: img02,
          title: "Top Spender",
          date: "24/11/2020",
          quantity: 100,
          awarded: 78,
          type: "Spending",
          status: "Active",
          connections: 1,
        },
      ],
      item: {},
      campaignId: null,
    };
  },
  mounted() {
    this.isLoad();
  },
  methods: {
    async isLoad() {
      //   this.items = await this.$repo.contest.joinableCampaigns();
    },
    getDate(date) {
      const m = moment(date);
      if (!m.isValid()) {
        return "";
      } else {
        return m.format("DD/MM/YYYY");
      }
    },
    getDateTime(date) {
      const m = moment(date);
      if (!m.isValid()) {
        return "";
      } else {
        return m.format("DD/MM/YYYY, HH:mm");
      }
    },
    showHastag(data) {},
    onClickAddContests() {
      this.showForm = true;
    },
    onClickAddRewards() {
        this.showRewardsForm = true;
    },
    onClickAddBadge() {
        this.showBadgesForm = true;
    },
    onJoinError(err) {
      this.$toasted.show(
        "Sorry for inconvenient. Something went wrong. Please try again later.",
        {
          type: "error",
        }
      );
    },
    onReset() {
      console.log("reset");
    },
    onSearch() {
      console.log("search");
    },
    showFormJoin(item) {
      this.alertJoinContest = false;
      this.showContestDetails = false;
      this.showForm = true;
      this.campaignId = item.id;
    },
    closeForm() {
      this.showForm = false;
      this.showContestDetails = true;
      this.alertJoinContest = false;
    },
    closeAlert() {
      this.showForm = true;
      this.showContestDetails = false;
      this.alertJoinContest = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: $breakpoint-tablet) {
  #rewarder {
    .ps {
      height: 85vh;
    }
    .contest-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 1fr;
      grid-gap: 30px;
      width: 100%;
    }

    .contest-item {
      display: flex;
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
      cursor: pointer;

      .contest-thumbnail {
        width: 42.85%;
        height: 100%;
        padding-bottom: 42.85%;
        position: relative;

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .contest-detail {
        padding: 10px 30px;
        background-color: #fff;
        flex: 1 1 auto;
      }

      .contest-title {
        font-size: 18px;
        font-weight: normal;
        margin: 0 0 16px;
      }

      .attributes {
        .attribute {
          display: grid;
          grid-template-columns: 85px 1fr;
          grid-auto-rows: 1fr;
          font-size: 12px;
          line-height: 1.75em;
        }
      }

      .approval-status {
        padding: 10px 5px;
        background-color: #8bc53f;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 40px;
        }
      }

      .contest-item.approved .approval-status {
        background-color: #1da1f2;
      }
    }
  }
}
@media only screen and (max-width: $breakpoint-tablet-ipad) {
  #join-contest {
    .ps {
      height: 85vh;
    }
    .contest-list {
      display: flex;
      flex-direction: column;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 1fr;
      grid-gap: 30px;
      width: 100%;
    }

    .contest-item {
      display: flex;
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
      cursor: pointer;

      .contest-thumbnail {
        width: 42.85%;
        height: 100%;
        padding-bottom: 42.85%;
        position: relative;

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .contest-detail {
        padding: 10px 30px;
        background-color: #fff;
        flex: 1 1 auto;
      }

      .contest-title {
        font-size: 18px;
        font-weight: normal;
        margin: 0 0 16px;
      }

      .attributes {
        .attribute {
          display: grid;
          grid-template-columns: 85px 1fr;
          grid-auto-rows: 1fr;
          font-size: 12px;
          line-height: 1.75em;
        }
      }

      .approval-status {
        padding: 10px 5px;
        background-color: #8bc53f;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 40px;
        }
      }

      .contest-item.approved .approval-status {
        background-color: #1da1f2;
      }
    }
  }
}
</style>
